import { EventEmitter, Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { AppGlobal } from '../../app.global';
import { airline_url } from '../../core/api-handlers';
import { ApiHandlerService } from '../../core/api-handlers/api-handlers.service';
import { AlertService } from '../../core/services/alert.service';
import { ModalConfigDataI } from '../../core/services/mat-modal.service';
import { SwalService } from '../../core/services/swal.service';
import { UtilityService } from '../../core/services/utility.service';

export function tempTraveller() {
    return {
        adults: 1,
        childrens: 1,
        infants: 0
    }
}
@Injectable({
    providedIn: 'root'
})
export class FlightService implements OnDestroy {
    protected subs = new SubSink();
    isDevelopment = false;
    currency = 'BDT';
    changeDetectionEmitter: EventEmitter<void> = new EventEmitter<void>();
    baggageFees = new BehaviorSubject<any>({});
    mealFees = new BehaviorSubject<any>({});
    bookingFlightData = new BehaviorSubject<any>(undefined);
    CommitBookingResponse = new BehaviorSubject<any>(undefined);
    edditedResponse = new BehaviorSubject<any>(undefined);
    FinalBookingResponse = new BehaviorSubject<any>(undefined);
    traveller: any = this.isDevelopment ? tempTraveller() : undefined;
    extraServices = new BehaviorSubject<any>(undefined);
    flightSearchData: BehaviorSubject<{}[]> = new BehaviorSubject<any>([]);
    resultToken: any;
    appReference: any;
    bookingSource = new BehaviorSubject<any>('');
    cabinClass: any;
    modalData: any;
    loading = new BehaviorSubject<boolean>(false);
    isCollapsed = new BehaviorSubject<boolean>(true);
    internalCall = false;
    private _flightsCopy: any = [];
    private _maxPrice: any = 0;
    private _minPrice: any = 0;
    originCountry = new BehaviorSubject<object>({});
    destCountry = new BehaviorSubject<object>({});
    flights = new BehaviorSubject<any>([]);
    calenderData=new BehaviorSubject<any>([]);
    public selectedFlight: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    flightsCopy = new BehaviorSubject<any>([]);
    maxPrice = new BehaviorSubject<any>(0);
    minPrice = new BehaviorSubject<any>(0);
    myValue = new BehaviorSubject<any>(0);
    myValueStart = new BehaviorSubject<any>(0);
    tripType = new BehaviorSubject<any>('Oneway');
    zeroStopActive = new BehaviorSubject<boolean>(true);
    oneStopActive = new BehaviorSubject<boolean>(true);
    multipleStopsActive = new BehaviorSubject<boolean>(true);
    multipleStopsPrice = new BehaviorSubject<boolean>(false);
    departureReset = new BehaviorSubject<boolean>(false);
    earlyMorning = new BehaviorSubject<boolean>(true);
    morning = new BehaviorSubject<boolean>(true);
    midDay = new BehaviorSubject<boolean>(true);
    evening = new BehaviorSubject<boolean>(true);
    arrivalReset = new BehaviorSubject<boolean>(false);
    earlyMorning2 = new BehaviorSubject<boolean>(true);
    morning2 = new BehaviorSubject<boolean>(true);
    midDay2 = new BehaviorSubject<boolean>(true);
    evening2 = new BehaviorSubject<boolean>(true);
    airlines = new BehaviorSubject<any>([]);
    airlinesReset = new BehaviorSubject<boolean>(false);
    nearbyAirports = new BehaviorSubject<any>([]);
    nearbyAirportsReset = new BehaviorSubject<boolean>(false);
    stopovers = new BehaviorSubject<any>([]);
    stopoversReset = new BehaviorSubject<boolean>(false);
    preferencesReset = new BehaviorSubject<boolean>(false);
    refundable = new BehaviorSubject<boolean>(true);
    nonRefundable = new BehaviorSubject<boolean>(true);
    baggage = new BehaviorSubject<boolean>(true);
    airlinesCarousel = new BehaviorSubject<any>([]);
    airlineCarouselClick = new BehaviorSubject<any>(null);
    serverError = new BehaviorSubject<boolean>(false);
    tripTypeClicked = false;
    formFilled: any = false;
    travellerFormFilled = new BehaviorSubject<any>([]);
    extraFees = new BehaviorSubject<any>({});
    searchingFlight = new BehaviorSubject<any>('');
    applySortingAfterFilter = new BehaviorSubject<boolean>(false);
    currentCurrency = new BehaviorSubject<string>(sessionStorage.getItem('selectedCurrency') || 'USD');
    currentCurrencyRate = new BehaviorSubject<number>(1);
    searchFlightSubmitted = false;
    searchResponseCopy = new BehaviorSubject<any>(false);
    roundTripCalendarList = new BehaviorSubject<any>([]);
    oneWayCalendarList = new BehaviorSubject<any>([]);
    userTitleList = new BehaviorSubject<any>(false);
    countryList = new BehaviorSubject<any>(false);
    nearByAirportsCopy = new BehaviorSubject<any>([]);
    noFlight = new BehaviorSubject<boolean>(false);
    flightType = new BehaviorSubject<any>('');
    private goToDashboardTabs = new BehaviorSubject<any>('');
    changeEmitted$ = this.goToDashboardTabs.asObservable();
    private sidebarClickEvents = new BehaviorSubject<any>('');
    changeSidebarTabs$ = this.sidebarClickEvents.asObservable();
    isBaggeProtected: BehaviorSubject<any> = new BehaviorSubject<any>(false);
    baggeProtectionData: BehaviorSubject<any> = new BehaviorSubject<any>({
        isProtected: false,
        data: {}
    });
    passengerDetails = new BehaviorSubject<any>([]);
    fareQuoteResp: BehaviorSubject<any> = new BehaviorSubject<any>({});
    modalConfigData: ModalConfigDataI;
    resultsFound: boolean = false;
    dialogClose = new BehaviorSubject<boolean>(false);
    editPassenger = new BehaviorSubject<boolean>(false);
    airline_logo = airline_url;
    bookingApiSources = [];    
    seatFees= new BehaviorSubject<any>({});
    promocode = new BehaviorSubject<any>({});
    flightPromocode = new BehaviorSubject<any>({});
    enebleSearch = new BehaviorSubject<boolean>(false);
    addNavTabsClass = new BehaviorSubject<boolean>(false);
    
    // Active filters for display in airline-features component
    activeFilters = new BehaviorSubject<Array<{label: string, value: string, type: string}>>([]);
    constructor(
        private apiHandlerService: ApiHandlerService,
        private utility: UtilityService,
        private alertService: AlertService,
    private appGlobal: AppGlobal,
        private swalService: SwalService
    ) { }


    duration(flight) {
        const time1 = flight;
        const dt11 = time1[0].Origin.DateTime;
        const dt12 = time1.length > 1 ? time1[time1.length - 1].Destination.DateTime : time1[0].Destination.DateTime;

        let totalDuration = '';
        let mins = 0, hrs = 0, day = 0;
        mins = this.diffMinutes(new Date(dt12), new Date(dt11))
        hrs += Math.floor(mins / 60);
        day = Math.floor(hrs / 24);
        hrs = hrs % 24;
        mins = mins % 60;
        totalDuration = day ? `${day} Day(s) ` : '';
        totalDuration += hrs ? `${hrs} Hr(s) ` : '';
        totalDuration += mins ? `${mins} Min(s)` : '';
        return totalDuration || '';
    }

    diffMinutes(dt2: any, dt1: any) {
        let diff = (dt2.getTime() - dt1.getTime()) / 1000;
        diff /= 60;
        return Math.abs(Math.round(diff));
    }

    counter: number = 0;
    // searchResult(data: any) {
    //     data.childDOB= data.childDOB.map((child) => child.childDateOfBirth);
    //     data.infantDOB= data.infantDOB.map((infant) => infant.infantDateOfBirth);
    //     data.Currency=this.appGlobal.selectedCurrency.value;
    //     const created_by_id = this.utility.readStorage('b2cUser', sessionStorage)['user_id'];
    //     this.searchFlightSubmitted = true;
    //     if (this.isDevelopment) {
    //     } else {
    //         this.searchingFlight.next(true);
    //         if ((data['PreferredAirlineName'] != 'All') && (data['PreferredAirlineName'] != 'All Airline')) {
    //             if (data['PreferredAirlines'][0] === 'BS') {
    //                 this.bookingApiSources = ['ZBAPINO00002','ZBAPINO00010'];

    //             } else if (data['PreferredAirlines'][0] === 'VQ' && !(data['JourneyType'] == 'multicity')) {
    //                 this.bookingApiSources = ['ZBAPINO00002','ZBAPINO00009'];
    //             } else {
    //                 this.bookingApiSources = ['ZBAPINO00002', 'ZBAPINO00003']; //ZBAPINO00003, ZBAPINO00007
    //             }
    //         }
    //         else {
    //             if (data['JourneyType'] == 'multicity') {
    //                 this.bookingApiSources = ['ZBAPINO00002','ZBAPINO00010', 'ZBAPINO00003']; //ZBAPINO00003, ZBAPINO00007
    //             }
    //             else {
    //                 this.bookingApiSources = ['ZBAPINO00002','ZBAPINO00010', 'ZBAPINO00009', 'ZBAPINO00003']; //ZBAPINO00003, ZBAPINO00007
    //             }
    //         }
    //        this.searchResultApi(data);
          
    //     }
    // }
    searchResult(data: any) {
        data.childDOB= data.childDOB.map((child) => child.childDateOfBirth);
        data.infantDOB= data.infantDOB.map((infant) => infant.infantDateOfBirth);
        // data.youthDOB = data.youthDOB.map((young) => young.youngDateOfBirth);
        // data.Currency=this.appGlobal.selectedCurrency.value;
        data.Currency = 'USD';
        const created_by_id = this.utility.readStorage('b2cUser', sessionStorage)['user_id'];
        this.searchFlightSubmitted = true;
        if (this.isDevelopment) {
        } else {
            this.searchingFlight.next(true);
            if ((data['PreferredAirlineName'] != 'All') && (data['PreferredAirlineName'] != 'All Airline')) {
                if (data['PreferredAirlines'][0] === 'BS') {
                    this.bookingApiSources = ['ZBAPINO00003'];

                } else if (data['PreferredAirlines'][0] === 'VQ' && !(data['JourneyType'] == 'multicity')) {
                    this.bookingApiSources = ['ZBAPINO00003'];
                } else {
                    this.bookingApiSources = ['ZBAPINO00003',]; //ZBAPINO00003, ZBAPINO00007
                }
            }
            else {
                if (data['JourneyType'] == 'multicity') {
                    this.bookingApiSources = ['ZBAPINO00003']; //ZBAPINO00003, ZBAPINO00007
                }
                else {
                    this.bookingApiSources = ['ZBAPINO00003']; //ZBAPINO00003, ZBAPINO00007
                }
            }
           this.searchResultApi(data);
          
        }
    }
    searchResultApi(data) {
        this.setSegments(data);
        this.seatFees.next(false);
        this.mealFees.next(false);
        this.baggageFees.next(false);
        this.oneWayCalendarList.next([]);
        this.roundTripCalendarList.next([]);
        this.flights.next([]);
       //  data['booking_source']='ZBAPINO00002';
    //    data.NonStopFlights= 1;
    //    data.PlusMinus3Days=1;
       data.booking_source = this.bookingApiSources[0];
        this.subs.sink = this.apiHandlerService.apiHandler('search', 'POST', '', '', data)
            .subscribe(
                searchResponse => {
                    if (searchResponse.Status && Object.keys(searchResponse.data).length) {
                        
                        if(searchResponse['data']['Search']['FlightDataList']['CalenderList'] && searchResponse['data']['Search']['FlightDataList']['CalenderList'].length && (data.JourneyType=="Oneway" || data.JourneyType=="OneWay")){
                            this.oneWayCalendarList.next(searchResponse['data']['Search']['FlightDataList']['CalenderList'][0]);
                        }
                        if(searchResponse['data']['Search']['FlightDataList']['CalenderList'] && searchResponse['data']['Search']['FlightDataList']['CalenderList'].length && data.JourneyType=="Return"){
                            this.roundTripCalendarList.next(searchResponse['data']['Search']['FlightDataList']['CalenderList'][0]);
                        }
                        this.flights.next([]);
                        let mergeResponseData = [...this.flights.value, ...searchResponse['data']['Search']['FlightDataList']['JourneyList'][0]];
                        mergeResponseData.forEach((element) => {
                            element.Price=element.Exchange_Price;
                        });
                        mergeResponseData = mergeResponseData.sort((a, b) => a.Price.TotalDisplayFare - b.Price.TotalDisplayFare);
                        if (mergeResponseData.length > 0 && data.Currency == 'USD' //this.appGlobal.selectedCurrency.value
                            ) {
                            this.hideLoader(); // added to hide loader soon after getting response from  one api
                        }
                        searchResponse['data']['Search']['FlightDataList']['JourneyList'][0] = mergeResponseData;
                       if(data.Currency == 'USD'
                        //this.appGlobal.selectedCurrency.value
                        ){
                        this.getResponse(searchResponse);
                       }
                        this.bookingApiSources.shift();
                        data.booking_source = this.bookingApiSources[0];
                        // data.NonStopFlights= 1;
                        // data.PlusMinus3Days=1;
                        if (this.bookingApiSources.length > 0) {
                           //  data['booking_source']='ZBAPINO00002';
                            this.searchResultApi(data);
                        }
                        else {
                            this.hideLoader();
                        }
                    } else {
                        this.noFlight.next(true);
                        this.alertService.error(searchResponse.Message);
                    }

                }, err => {
                    if (err.error.statusCode === 400) {
                        this.bookingApiSources.shift();
                        data.booking_source = this.bookingApiSources[0];
                        if (this.bookingApiSources.length > 0) {
                           //  data['booking_source']='ZBAPINO00002';
                            this.searchResultApi(data);
                        }
                        else {
                            this.hideLoader();
                        }

                    } else if (err.error.statusCode != 500) {
                        this.noFlight.next(true);
                        this.hideLoader();
                        this.swalService.alert.oops(err.error.Message);
                    } else {
                        this.bookingApiSources.shift();
                        data.booking_source = this.bookingApiSources[0];
                        if (this.bookingApiSources.length > 0) {
                           // data['booking_source']='ZBAPINO00002';
                            this.searchResultApi(data);
                        }
                        else {
                            this.hideLoader();
                        }
                    }
                }
            );
    }


    hideLoader(){
        this.loading.next(false);
        this.searchingFlight.next(false);
        this.resultsFound = false;
        this.dialogClose.next(true);
    }


    getResponse(searchResponse) {
        this.searchResponseCopy.next(JSON.parse(JSON.stringify(searchResponse)));
        const usdResult = searchResponse.data.Search.FlightDataList.JourneyList[0];
        this.nearByAirportsCopy.next(searchResponse.data.Search.NearByAirports);
        this.flights.next(usdResult);
        const flightsCopy = JSON.parse(JSON.stringify(usdResult));
        this.flightsCopy.next(flightsCopy);
        this._flightsCopy = flightsCopy;

        const maxPrice = flightsCopy.reduce(function (prev, curr) {
            return Number(prev.Price.TotalDisplayFare) > curr.Price.TotalDisplayFare ? prev : curr;
        }, { Price: { TotalDisplayFare: 0 } }).Price.TotalDisplayFare;

        this.maxPrice.next(maxPrice);
        this._maxPrice = maxPrice;

        const minPrice = flightsCopy.reduce(function (prev, curr) {
            return Number(prev.Price.TotalDisplayFare) < curr.Price.TotalDisplayFare ? prev : curr;
        }, { Price: { TotalDisplayFare: maxPrice } }).Price.TotalDisplayFare;
        this.minPrice.next(minPrice);
        this._minPrice = minPrice;
        this.myValue.next(maxPrice);
        this.myValueStart.next(minPrice);

        const airlinesTemp = [];
        flightsCopy.forEach(flight => {
            airlinesTemp.push(flight.FlightDetails.Details[0][0].OperatorName);
        });
        const airlines = airlinesTemp.filter((x, i, a) => a.indexOf(x) == i);

        const airlinesTemp2 = [];
        airlines.forEach((element, i) => {
            airlinesTemp2.push({ name: airlines[i], isChecked: true });
        });
        this.airlines.next(airlinesTemp2);
        const tempNearbyAirport = [];
        flightsCopy.forEach(flight => {
            const tempFlight = flight.FlightDetails.Details[0];
            if (tempFlight.length === 2) {
                tempNearbyAirport.push(flight.FlightDetails.Details[0][1].Origin.AirportName);
            }
        });
        const nearbyAirports = tempNearbyAirport.filter((x, i, a) => a.indexOf(x) == i);
        const airportsTemp2 = [];
        nearbyAirports.forEach((element, i) => {
            airportsTemp2.push({ name: nearbyAirports[i], isChecked: true });
        });
        const tempStopovers = [];
        flightsCopy.forEach(flight => {
            const tempFlight = flight.FlightDetails.Details[0];
            if (tempFlight.length > 1) {
                tempFlight.forEach((e, i) => {
                    if (i < tempFlight.length - 1) {
                        tempStopovers.push(e.Destination.CityName);
                    }
                });
            }
        });
        const Stopovers = tempStopovers.filter((x, i, a) => a.indexOf(x) == i);
        const tempStopovers2 = [];
        Stopovers.forEach((element, i) => {
            tempStopovers2.push({ name: Stopovers[i], isChecked: true });
        });

        this.stopovers.next(tempStopovers2);
        this.changeDetectionEmitter.emit();
    }

    resetFilter() {
        this.internalCall = false;
        this.flights.next(this._flightsCopy);
        this.maxPrice.next(this._maxPrice);
        this.minPrice.next(this._minPrice);
        this.myValue.next(this._maxPrice);
        this.myValueStart.next(this._minPrice);
        this.zeroStopActive.next(true);
        this.oneStopActive.next(true);
        this.multipleStopsActive.next(this.multipleStopsPrice.value);
        this.departureReset.next(true);
        this.arrivalReset.next(true);
        this.nearbyAirportsReset.next(true);
        this.stopoversReset.next(true);
        this.preferencesReset.next(true);
        this.airlinesReset.next(true);
        this.changeDetectionEmitter.emit();
    }

    getCabinClass(): Observable<any> {
        if (!this.cabinClass) {
            this.cabinClass = this.apiHandlerService.apiHandler('cabinClass', 'POST')
                .pipe(
                    map(response => response['Data']['CabinClass']),
                    shareReplay(1)
                );
        }
        return this.cabinClass;
    }

    stops(flight: any) {
        return flight.FlightDetails.Details[0].length - 1;
    }

    filterByAirlines() {
        this.multipleFiltersApply();
    }
    multipleFiltersApply() {
        let flights = this.changeSliderExt();
        flights = this.filterByStopsExt(flights);
        flights = this.filterByDepartureTimeExt(flights);
        flights = this.filterByArrivalTimeExt(flights);
        flights = this.filterByAirlinesExt(flights);
        flights = this.filterByNearestAirportExt(flights);
        flights = this.filterByStopoverCityExt(flights);
        flights = this.filterByPreferencesExt(flights);
        this.flights.next(flights);
        /* apply sorting */
        this.applySortingAfterFilter.next(true);
        this.changeDetectionEmitter.emit();
    }

    changeSlider() {
        this.multipleFiltersApply();
    }

    filterByStops() {
        this.multipleFiltersApply();
    }

    changeSliderExt() {
        this.myValue.next(Math.ceil(this.myValue.value+1));
        this.myValueStart.next(Math.floor(this.myValueStart.value));
        const result = this._flightsCopy.filter(flight => {
            const result = flight.Price.TotalDisplayFare <= this.myValue.value && flight.Price.TotalDisplayFare >= this.myValueStart.value;
            return result;
        });
        return !result.length ? this._flightsCopy : result;
    }

    filterByStopsExt(flights) {
        const zeroStop = this.zeroStopActive.value;
        const oneStop = this.oneStopActive.value;
        const multipleStops = this.multipleStopsActive.value;

        const flightsCopyTemp = JSON.parse(JSON.stringify(flights));

        if (!zeroStop && !oneStop && !multipleStops) {
            flights = flightsCopyTemp;
        } else if (!zeroStop && !oneStop && multipleStops) {
            flights = flightsCopyTemp.filter(flight => {
                return flight.FlightDetails.Details[0].length > 2;
            });
        } else if (!zeroStop && oneStop && !multipleStops) {
            flights = flightsCopyTemp.filter(flight => {
                return flight.FlightDetails.Details[0].length === 2;
            });
        } else if (!zeroStop && oneStop && multipleStops) {
            flights = flightsCopyTemp.filter(flight => {
                return flight.FlightDetails.Details[0].length > 1;
            });
        } else if (zeroStop && !oneStop && !multipleStops) {
            flights = flightsCopyTemp.filter(flight => {
                return flight.FlightDetails.Details[0].length === 1;
            });
        } else if (zeroStop && !oneStop && multipleStops) {
            flights = flightsCopyTemp.filter(flight => {
                return flight.FlightDetails.Details[0].length !== 2;
            });
        } else if (zeroStop && oneStop && !multipleStops) {
            flights = flightsCopyTemp.filter(flight => {
                return flight.FlightDetails.Details[0].length <= 2;
            });
        } else {
            flights = flightsCopyTemp;
        }
        return flights;
    }

    filterByDepartureTime() {
        this.multipleFiltersApply();
    }

    setSegments(data) {
        for (let segment of data.Segments) {
            segment.Destination.includes('-') ? segment.Destination = segment.Destination.split('-')[1] : segment.Destination;
            segment.Origin.includes('-') ? segment.Origin = segment.Origin.split('-')[1] : segment.Origin;
        }
    }


    filterByDepartureTimeExt(flights) {
        const a = this.earlyMorning.value;  // 12 AM - 6 AM
        const b = this.morning.value;       // 6 AM - 12 PM
        const c = this.midDay.value;    // 12 PM - 6 PM
        const d = this.evening.value;       // 6 PM - 12 AM
    
        const flightsCopyTemp = JSON.parse(JSON.stringify(flights));
        let tempFlights;
    
        if (!a && !b && !c && !d) {
            tempFlights = flights;
        } else if (a && !b && !c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 0 && t < 6;  // 12 AM - 6 AM
            });
        } else if (!a && b && !c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 6 && t < 12;  // 6 AM - 12 PM
            });
        } else if (!a && !b && c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 12 && t < 18;  // 12 PM - 6 PM
            });
        } else if (!a && !b && !c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return (t >= 18 && t < 24);  // 6 PM - 12 AM
            });
        } else if (a && b && !c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 0 && t < 12;  // 12 AM - 12 PM
            });
        } else if (a && !b && c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 0 && t < 18;  // 12 AM - 6 PM
            });
        } else if (a && !b && !c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 0 && (t >= 18 && t < 24);  // 12 AM - 6 AM OR 6 PM - 12 AM
            });
        } else if (!a && b && c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 6 && t < 18;  // 6 AM - 6 PM
            });
        } else if (!a && b && !c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 6 && t < 24;  // 6 AM - 12 AM
            });
        } else if (!a && !b && c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 6 && t < 24;  // 6 AM - 12 AM
            });
        } else if (a && b && c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 0 && t < 18;  // 12 AM - 6 PM
            });
        } else if (a && b && !c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 0 && t < 24;  // 12 AM - 12 AM
            });
        } else if (a && b && c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const depTime = flight.FlightDetails.Details[0][0].Origin.DateTime;
                const t = (new Date(depTime)).getHours();
                return t >= 0 && t < 24;  // 12 AM - 12 AM
            });
        } else {
            tempFlights = flights;
        }
    
        return tempFlights;
    }
    

    filterByArrivalTime() {
        this.multipleFiltersApply();
    }

    filterByArrivalTimeExt(flights) {
        const a = this.earlyMorning2.value;  // 12 AM - 6 AM
        const b = this.morning2.value;       // 6 AM - 12 PM
        const c = this.midDay2.value;       // 12 PM - 6 PM
        const d = this.evening2.value;       // 6 PM - 12 AM
    
        const flightsCopyTemp = JSON.parse(JSON.stringify(flights));
        let tempFlights;
    
        if (!a && !b && !c && !d) {
            tempFlights = flights;
        } else if (a && !b && !c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 0 && t < 6;  // 12 AM - 6 AM
            });
        } else if (!a && b && !c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 6 && t < 12;  // 6 AM - 12 PM
            });
        } else if (!a && !b && c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 12 && t < 18;  // 12 PM - 6 PM
            });
        } else if (!a && !b && !c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 18 && t < 24;  // 6 PM - 12 AM
            });
        } else if (a && b && !c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 0 && t < 12;  // 12 AM - 12 PM
            });
        } else if (a && !b && c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 0 && t < 18;  // 12 AM - 6 PM
            });
        } else if (a && !b && !c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 0 && (t >= 18 && t < 24);  // 12 AM - 6 AM OR 6 PM - 12 AM
            });
        } else if (!a && b && c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 6 && t < 18;  // 6 AM - 6 PM
            });
        } else if (!a && b && !c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 6 && t < 24;  // 6 AM - 12 AM
            });
        } else if (!a && !b && c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 6 && t < 24;  // 6 AM - 12 AM
            });
        } else if (a && b && !c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 0 && t < 18;  // 12 AM - 6 PM
            });
        } else if (a && b && !c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 0 && t < 24;  // 12 AM - 12 AM
            });
        } else if (a && b && c && !d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 0 && t < 18;  // 12 AM - 6 PM
            });
        } else if (a && b && c && d) {
            tempFlights = flightsCopyTemp.filter(flight => {
                const arrivalTime = flight.FlightDetails.Details[0][this.stops(flight)].Destination.DateTime;
                const t = (new Date(arrivalTime)).getHours();
                return t >= 0 && t < 24;  // 12 AM - 12 AM
            });
        } else {
            tempFlights = flights;
        }
    
        return tempFlights;
    }
    


    filterByAirlinesExt(flights) {
        const tempAirlines = this.airlines.value.filter(f => f.isChecked);
        if (this.airlines.value.length === tempAirlines.length || tempAirlines.length === 0) {
            return flights;
        }
        const flightsCopyTemp = JSON.parse(JSON.stringify(flights));
        const tempFlights = flightsCopyTemp.filter(flight => {
            const result = this.airlines.value.find(t => t.name === flight.FlightDetails.Details[0][0].OperatorName);
            return result.isChecked || result.isChecked==1;
        });
        return tempFlights;
    }

    filterByNearestAirport() {
        this.multipleFiltersApply();
    }

    priceFilter() {
        let flights = this.changeSliderExt();
        this.flights.next(flights);
        this.applySortingAfterFilter.next(true);
        this.changeDetectionEmitter.emit();
    }

    filterByNearestAirportExt(flights) {
        const tempData = [];
        this.nearbyAirports.value.forEach(e => {
            if (e.isChecked) {
                tempData.push(e.code);
            }
        });
        if (tempData.length === 0 || tempData.length === this.nearbyAirports.value.length) {
            return flights;
        }
        const flightsCopyTemp = JSON.parse(JSON.stringify(flights));
        const tempFlights2 = flightsCopyTemp.filter(flight => {
            let returnResult1 = false;
            let returnResult2 = false;
            flight.FlightDetails.Details[0].forEach((t, i) => {
                if (tempData.includes(t.Origin.AirportCode)) {
                    returnResult1 = true;
                }
            });
            flight.FlightDetails.Details[flight.FlightDetails.Details.length - 1].forEach((t, i) => {
                if (tempData.includes(t.Destination.AirportCode)) {
                    returnResult2 = true;
                }
            });
            return returnResult1 && returnResult2;
        });
        return tempFlights2;
    }

    filterByStopoverCity() {
        this.multipleFiltersApply();
    }

    filterByStopoverCityExt(flights) {
        const tempData = [];
        this.stopovers.value.forEach(e => {
            if (e.isChecked) {
                tempData.push(e.name);
            }
        });
        if (tempData.length === 0 || tempData.length === this.stopovers.value.length) {
            return flights;
        }
        const flightsCopyTemp = JSON.parse(JSON.stringify(flights));
        const tempFlights = flightsCopyTemp.filter(flight => {
            let returnResult = false;
            flight.FlightDetails.Details[0].forEach((t, i) => {
                if (tempData.includes(t.Destination.CityName)) {
                    returnResult = true;
                }
            });
            return returnResult || !tempData.length;
        });
        return tempFlights;
    }

    filterByPreferences() {
        this.multipleFiltersApply();
    }

    filterByPreferencesExt(flights) {
        const a = this.refundable.value;
        const b = this.nonRefundable.value;
        // const c = this.baggage.value;
            if ((a && b) || (!a && !b)) {
                return flights
            }
            const flightsCopyTemp = JSON.parse(JSON.stringify(flights));
            if (a && !b) {
                flights = flightsCopyTemp.filter((flight) => flight.Attr.IsRefundable);
            } else if (!a && b) {
                flights = flightsCopyTemp.filter((flight) => !flight.Attr.IsRefundable);
            } else if (!a && !b) {
                let flightsTemp = flightsCopyTemp.filter((flight) => flight.Attr.IsRefundable === "");

                if (flightsTemp)
                    flights = flightsTemp;
                else
                    flights = [];
            }
            return flights;
      
    }

    // filterByPreferencesExtTM(flights, a, b) {
    //     if ((a && b)) {
    //         return flights
    //     }
    //     const flightsCopyTemp = JSON.parse(JSON.stringify(flights));
    //     if (a && !b) {
    //         for (let index = 0; index < flightsCopyTemp.length; index++) {
    //             flights[index] = flightsCopyTemp[index].filter((flight) => flight.Attr.IsRefundable);
    //         }

    //     } else if (!a && b) {
    //         for (let index = 0; index < flightsCopyTemp.length; index++) {
    //             flights[index] = flightsCopyTemp[index].filter((flight) => !flight.Attr.IsRefundable);
    //         }
    //     } else if (!a && !b) {
    //         let flightsTemp = [];
    //         for (let index = 0; index < flightsCopyTemp.length; index++) {
    //             flightsTemp = flightsCopyTemp[index].filter((flight) => flight.Attr.IsRefundable === "");
    //         }
    //         if (flightsTemp)
    //             flights = flightsTemp;
    //         else
    //             flights = [];
    //     }
    //     return flights;
    // }
    resetSearch() {
        this.flightsCopy.next([]);
        this.flights.next([]);
        this.maxPrice.next(0);
        this.minPrice.next(0);
        this.myValue.next(0);
        this.myValueStart.next(0);
        this.departureReset.next(false);
        this.arrivalReset.next(false);
        this.nearbyAirportsReset.next(false);
        this.stopoversReset.next(false);
        this.preferencesReset.next(false);
        this.airlinesReset.next(false);
        this.changeDetectionEmitter.emit();
    }

    setInvoiceNumber(appReference) {
        let invoiceNumber = "";
        if (appReference) {
            invoiceNumber = "INV-" + (appReference.split("-")[1]);
        }
        return invoiceNumber;
    }
    setFlightTraveller(){
        const storedState = localStorage.getItem('flightTraveller');
        if (storedState) {
            this.traveller=(JSON.parse(storedState));
        }
    }

    setJourneyListPre() {
        const storedState = localStorage.getItem('journeyListPre');
        if (storedState) {
            this.bookingFlightData.next(JSON.parse(storedState));
        }
    }

    setBookingSource() {
        const storedState = localStorage.getItem('bookingSource');
        if (storedState) {
            this.bookingSource.next(storedState);
        }
    }

    setResultToken() {
        const storedState = localStorage.getItem('resultToken');
        if (storedState) {
            this.resultToken=storedState;
        }
    }

    setPassengerDetails(){
        const storedState = localStorage.getItem('passengerDetails');
        if (storedState) {
            this.passengerDetails.next(JSON.parse(storedState));
        }
    }

    setCountryList(){
        const storedState = localStorage.getItem('flightCountryList');
        if (storedState) {
            this.countryList.next(JSON.parse(storedState));
        }
    }
    setLocalStrorage(journeyListPre,resultTokendata){
        localStorage.setItem('journeyListPre', JSON.stringify(journeyListPre));
        localStorage.setItem('bookingSource', resultTokendata.booking_source);
        localStorage.setItem('resultToken', journeyListPre.JourneyList.ResultToken);
        localStorage.setItem('flightTraveller', JSON.stringify(this.traveller));
    }
    setCommitBookingResponse()
    {
        const storedState = localStorage.getItem('flightCommitBookingResponse');
        if (storedState) {
            this.CommitBookingResponse.next(JSON.parse(storedState));
        }
    }
    setMealFee() {
        const storedState = localStorage.getItem('mealFee');
        if (storedState) {
            this.mealFees.next({
                mealFee: JSON.parse(storedState)
            });
        }
    }
    
    setBaggageFee() {
        const storedState = localStorage.getItem('baggageFee');
        if (storedState) {
            this.baggageFees.next({
                baggageFee: JSON.parse(storedState)
            });
        }
    }

    // setPromoCode(){
    //     const storedState = localStorage.getItem('promocode');
    //     if (storedState) {
    //         this.promocode.next({
    //             promocode: JSON.parse(storedState)
    //         });
    //     }
    // }
    
  setPromoCode() {
    const storedState = localStorage.getItem('flightPromocode');
    if (storedState) {
      this.flightPromocode.next({
        promocode: JSON.parse(storedState)
      });
    }
  }
  
//   convertDurationToMinutes(durationString) {
//     let hours;
//     let minutes;
//     const parts = durationString.split(' ');
//     for (let i = 0; i < parts.length; i++) {
//         if (parts[i].toLowerCase() === 'hrs') {
//             hours = parseInt(parts[i - 1]);
//         } else if (parts[i].toLowerCase() === 'mins') {
//             minutes = parseInt(parts[i - 1]);
//         }
//     }
//     return parseInt(hours) * 60 + parseInt(minutes);
//  }
convertDurationToMinutes(duration: string): number {
    if (!duration) return 0;

    // Remove extra spaces and convert to lower case for consistency
    duration = duration.trim().toLowerCase();

    // Match hours and minutes from string
    const hoursMatch = duration.match(/(\d+)\s*hrs?/);
    const minutesMatch = duration.match(/(\d+)\s*mins?/);

    const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
    const minutes = minutesMatch ? parseInt(minutesMatch[1], 10) : 0;

    return (hours * 60) + minutes;
}

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }
}
